import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://venteaterme.fr";

export default function SEO({ title, description, canonical, schema }) {
  const { pathname } = useLocation();
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let m = document.querySelector('meta[name="description"]');
      if (!m) {
        m = document.createElement("meta");
        m.name = "description";
        document.head.appendChild(m);
      }
      m.setAttribute("content", description);
    }
    // Canonical link
    const href = canonical || `${BASE_URL}${pathname}`;
    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", href);
    // OG updates
    const setOg = (prop, val) => {
      if (!val) return;
      let el = document.querySelector(`meta[property="${prop}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", prop);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };
    setOg("og:title", title);
    setOg("og:description", description);
    setOg("og:url", href);
    // Optional schema.org JSON-LD injection (single instance per page)
    let ld = document.getElementById("page-jsonld");
    if (schema) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "page-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(schema);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, canonical, pathname, schema]);
  return null;
}
